import { render, staticRenderFns } from "./ManageDownloadCenter.vue?vue&type=template&id=6bc1bd34&scoped=true&"
import script from "./ManageDownloadCenter.vue?vue&type=script&lang=js&"
export * from "./ManageDownloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./ManageDownloadCenter.vue?vue&type=style&index=0&id=6bc1bd34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc1bd34",
  null
  
)

export default component.exports